<template>
  <section
    v-if="specializations.length"
    class="lpu-specializations"
    data-qa="lpu_specializations"
  >
    <CoreSwiper
      v-if="isMobile"
      free-mode
      slides-per-view="auto"
      :has-pagination="false"
      :space-between="16"
      :placeholder-min-height="220"
      class="mx-n2 px-2"
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="(item, index) in specializations"
          :key="item.speciality.id"
          v-bind="slideAttrs"
        >
          <SpecializationItem
            class="h-100"
            :is-primary="index % 2 === 0"
            :lpu-doctors-url="lpuDoctorsUrl"
            :specialization="item"
            :text-btn="goToBtnText"
          />
        </div>
      </template>
    </CoreSwiper>
    <div
      v-else
      class="lpu-specializations__list ga-4"
    >
      <SpecializationItem
        v-for="(item, index) in specializations"
        :key="item.speciality.id"
        :is-primary="index % 2 === 0"
        :lpu-doctors-url="lpuDoctorsUrl"
        :specialization="item"
        :text-btn="goToBtnText"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useURLStore from 'src/store/useURLStore'
import useContextStore from 'src/store/useContextStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import type { Lpu, LpuBrandingSpecialization } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import SpecializationItem from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuSpecializations/components/SpecializationItem.vue'

const props = defineProps<{
  specializations: LpuBrandingSpecialization[]
  lpu: Lpu
}>()

const isMobile = useIsMobile()
const goToBtnText = tStatic('Перейти')
const { urlLang }: CommonContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const lpuDoctorsUrl = reverseFullL10N({
  name: 'lpu_doctors',
  args: {
    language: urlLang,
    town_translit: props.lpu.town.translit,
    lpu_translit: props.lpu.translit,
  },
})
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.lpu-specializations {
  :deep(.swiper-container) {
    width: auto;

    .swiper-wrapper {
      align-items: stretch;
    }

    .swiper-slide {
      height: auto;
      width: 259px !important;
    }
  }

  &__list {
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(228px, 1fr));
    align-items: stretch !important;
  }
}
</style>
